<template>
  <v-container fluid class="border">
    
    <div
    :class="{ loader: true}"
    class="app-name"
    >
      <div class="text-right mt-8 mr-8">
        <img v-bind:src="($config.VUE_APP_CLIENT_BASED_CONFIG.logo)?$config.VUE_APP_CLIENT_BASED_CONFIG.logo:''" width="18%" class="d-inline-flex">
      </div>        
        <div v-if="connection" class="server" >
          {{$t('connecting')}}
        </div>  
        <div v-else class="server">
          {{$t('connectionFailure')}}
        </div>
        <v-btn
          elevation="2"
          icon
          loading
          text
          v-if="connection"
          color="#0d5ae5"
        ></v-btn>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "LoadingScreen",
  props: ["isLoading"],
  data () {
    return {
      connection: true,
      retries: 0
    }
  },
  mounted(){
    try {
      this.$store.dispatch('authenticate','/').then()
      .catch(e=> {
        this.connection = false
        console.log("catch",e)
      })
    }catch(e) {
      this.connection = false
      console.log("connection error: ",e)
    }
    this.checkConection()
  },
  methods: {
    checkConection(){
      var that = this
      setTimeout(function() {
        that.connection = false
      },16000)
    }
  }
};
</script>

<style>

.border{
  margin: 0;
  padding: 0;
  background-color: #f5f5f5;
}
.server{
  color: #0d5ae5!important;
  font-size: 21px;
  font-weight:lighter!important;
  margin-top: 15px;
  font-family: 'Roboto', 'sans-serif';
  font-weight: 500!important;
}
.loader {
  bottom: 0;
  color: black;
  display: block;
  font-size: 32px;
  left: 0;
  overflow: hidden;
  padding-top: 10vh;
  position: fixed;
  right: 0;
  text-align: center;
  top: 0;
}

.fadeout {
  animation: fadeout 2s forwards;
}

@keyframes fadeout {
  to {
    opacity: 0;
    visibility: hidden;
  }
}
</style>